import { useState, useEffect, useRef } from "react";
import { User, LogOut } from "lucide-react";
import { useAuth } from "../../../context/AdminAuthContext";

const Header = ({ title, desc }) => {
  const { logout, auth } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="bg-[#f5f0ff] rounded-t-xl border-b pb-3 w-full border-[#0000001A]">
      <div className="flex justify-between items-center w-full">
        <div className="!flex !flex-col !items-start">
          <div className="text-2xl font-bold text-black pb-1">{title}</div>
          <span className="text-base font-normal text-grey">{desc}</span>
        </div>

        <div className="flex items-center gap-3">
          <span className="text-sm font-medium text-[#4424A7]">
            {auth?.email}
          </span>
          <div className="cursor-pointer relative" ref={menuRef}>
            <div
              onClick={() => setMenuOpen((prev) => !prev)}
              className="w-10 h-10 rounded-full bg-white border border-[#ccc] flex items-center justify-center"
            >
              <User className="text-[#4424A7] w-5 h-5" />
            </div>

            {menuOpen && (
              <div className="absolute cursor-pointer right-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-md z-10">
                <div
                  onClick={logout}
                  className="w-full flex items-center gap-2 px-4 py-3 text-sm rounded-lg text-red-600 hover:bg-darkblue hover:text-white"
                >
                  <LogOut className="w-4 h-4" />
                  Logout
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
